var OCS = OCS || {};
OCS.Viewer = OCS.Viewer || {};
OCS.Viewer.Classes = OCS.Viewer.Classes || {};
OCS.Viewer.Functions = OCS.Viewer.Functions || {};
OCS.Viewer.Functions.define_RadarLayerGroup = function (in_implements, in_extends, options) {
    var class_definition = OCS.Viewer.Functions.define_CanvasLayerGroup(in_implements, in_extends, options);
    return new Class({
        Extends: class_definition,
        class_name: "RadarLayerGroup",
        get_layer_short_name: function () {
            if (!this.options.layer_short_name) {
                var variable = this.get_variables()[0];
                this.options.layer_short_name = "Radar " + variable.parm + " " + variable.site;
            }
            return this.options.layer_short_name;

        },
        get_layer_name: function () {
            if (!this.options.layer_name) {
                var variable = this.get_variables()[0];
                this.options.layer_name = "Radar " + variable.parm + " " + variable.site;
            }
            return this.options.layer_name;
        },
        get_legend_status_text: function (trackLonLat) {
            var source = this.get_source_obj();
            var html_info = "";
            if (source) {
                var stats = source.valueFromLonLat(trackLonLat);
                if (stats) {
                    var range = stats.range;
                    var height = stats.beamHeight;
                    html_info = 'Range: ' + Math.round(range.mi) + ' mi.';
                    if (height) {
                        html_info += ' - Ht: ' + Math.round(height.ft) + ' ft.';
                    }
                    html_info += ' - ' + source.radar_mode() + ' Mode';
                    var strm_tot_times = source.get_strm_tot_times();
                    if (strm_tot_times) {
                        html_info += ' - Begin: ' + moment(strm_tot_times.begin).format('M/D/YYYY H:MM A');
                    }
                    html_info += " - " + trackLonLat[1].toFixed(3) + '&deg; N, ' + Math.abs(trackLonLat[0]).toFixed(3) + '&deg; W';
                }
            }
            return html_info;
        },

    });
};
OCS.Viewer.Classes.RadarLayerGroup = OCS.Viewer.Functions.define_RadarLayerGroup();
